export default function Project({ project, index }){

    const { name, title, description, url } = project

    return (
        <div
            data-aos="fade-left"
            data-aos-anchor=".aos-progetti"
            data-aos-delay={`${index * 100 + 200}`}
        >
            <div className="row align-items-center d-none d-md-flex">
                    
                <div className="col-1 dot">
                    <i className="fas fa-circle fa-xs"></i>
                </div>
                <div className="col">
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        <h5>{name}</h5>
                    </a>
                </div>
                
            </div>
            
            {/* SOLO MOBILE */}

            <div className="row align-items-center d-md-none ms-0">
                <div className="col-1 dot">
                </div>
                <div className="col date-mobile ps-0">
                    <a href={url} target="_blank" rel="noopener noreferrer"><h5>{name}</h5>
                    </a>
                </div>
            </div>
            
            <div className="row align-items-center mt-1 ms-0">
                <div className="col-1 dot"> 
                </div>
                <div className="col ps-1">
                    <p>
                        <strong>{title}</strong> - {description}
                    </p>
                </div>
            </div>
        </div>
    )
}